function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 30.0001C17.1586 29.6156 16.3275 28.891 15.4908 27.7654C14.6541 26.6398 14.2063 25.2684 14.2161 23.8615C14.1829 22.2578 14.7412 20.6989 15.7827 19.487C16.8242 18.2752 18.2747 17.4967 19.8528 17.3027C21.4309 17.1086 23.0242 17.5128 24.3236 18.4368C25.6231 19.3608 26.5362 20.7388 26.8858 22.3036",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6301 14.1145V10",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.276 18.9879L8.75226 16.9106",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.276 28.7349L8.75226 30.7721",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9841 18.9879L32.5475 16.9106",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.0521 27.1771C33.8863 25.7402 33.2007 24.4156 32.1266 23.4573C31.0526 22.4989 29.6657 21.9743 28.232 21.984C27.3361 21.9779 26.4509 22.1805 25.6453 22.5761C24.8397 22.9717 24.1355 23.5496 23.5876 24.2648C23.0397 24.98 22.6629 25.8132 22.4864 26.6994C22.3099 27.5856 22.3386 28.501 22.5702 29.3742C22.2055 29.2274 21.8144 29.1594 21.422 29.1744C20.7857 29.1146 20.1441 29.1895 19.5381 29.3941C18.9321 29.5988 18.375 29.9288 17.9027 30.3631C17.4303 30.7974 17.053 31.3263 16.7948 31.9161C16.5366 32.5059 16.4033 33.1435 16.4033 33.7883C16.4033 34.433 16.5366 35.0707 16.7948 35.6605C17.053 36.2503 17.4303 36.7792 17.9027 37.2135C18.375 37.6477 18.9321 37.9777 19.5381 38.1824C20.1441 38.3871 20.7857 38.4619 21.422 38.4021H35.8733C37.1369 38.1158 38.2661 37.404 39.0753 36.3839C39.8844 35.3638 40.3254 34.0962 40.3254 32.7896C40.3254 31.483 39.8844 30.2154 39.0753 29.1953C38.2661 28.1752 37.1369 27.4634 35.8733 27.1771C35.2693 27.0902 34.6561 27.0902 34.0521 27.1771Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgWeatherForecasting = function SvgWeatherForecasting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeatherForecasting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weather-forecasting.40bc9a27.svg";
export { ForwardRef as ReactComponent };